module.exports = __webpack_public_path__ + "img/laboratorio3_4-3_1024.92e63037.webp";